<!-- eslint-disable -->
<template lang="pug">
    .row.user-preview(
        :class="userPreviewClasses"
    )
        .col-xs-12.col-md-2.col-xl-1.user-preview__column.user-preview__column_with-trophy(:class="getColor(places.system)")
            i.fa.fa-trophy(v-if="place < 4", :class="color")
            span.user-preview__place {{ place }}
        .row.col-xs-12.col-md-8.col-xl-11
            .col-xs-12.col-xl-6.user-preview__column
                small-user-preview(:displayed-user="rating.user")
                    .user-info(slot="info")
                        .user-info(v-for="school in rating.user.schools")
                            svg-icon.user-preview__icon(name="university")
                            template(v-if="school")
                                router-link.user-preview__link.preview__text(
                                    v-if="user.type !== 'student'"
                                    :to="{name: 'school:profile', params: {id: school.id}}"
                                )
                                    | {{ school.name }}
                                .preview__text(v-else)
                                    | {{ school.name }}
                            template(v-else)
                                | {{ $i18n.t('list.list_common_noSchool') }}
                            .user-info(
                                v-if="schoolGrades(school).length"
                                v-for="grade in schoolGrades(school)"
                            )
                                svg-icon.user-preview__icon(name="list-inverse")
                                router-link.user-preview__link.preview__text(
                                    :to="{name: 'grade:profile', params: {id: grade.id}}"
                                )
                                    | {{ grade.name }}
                            div(v-else)
                                | {{ $i18n.t('list.list_common_noGrade') }}
            .col-xs-12.col-xl-6.user-preview__column
                .row.user-preview__info
                    .col-xs-3.info__column
                        svg-icon.user-preview__icon(name="goal")
                        .preview__text {{ places.system > 500 ? '500+' : places.system }}
                    .col-xs-3.info__column
                        svg-icon.user-preview__icon(name="university")
                        .preview__text {{ places.school }}
                    .col-xs-3.info__column
                        svg-icon.user-preview__icon(name="tablet")
                        .preview__text {{ places.grade }}
                    .col-xs-3.info__column
                        svg-icon.user-preview__icon(name="coin")
                        .preview__text {{ rating.points }}
</template>

<script>
    /*eslint-disable*/
    import Dropdown from '../../../elements/Dropdown.vue';
    import {mapState} from 'vuex';
    import authentication from '../../../utils/user/authentication';
    import SmallUserPreview from '../../profiles/default-elements/SmallUserPreview.vue';

    export default {
        props: {
            rating: Object,
            index: Number,
            perPage: Number,
            searchParams: Object,
            prevRating: Object
        },
        mixins: [authentication],
        components: {
            SmallUserPreview,
            Dropdown
        },
        methods: {
            getColor (place) {
                return {
                    gold: place === 1,
                    silver: place === 2,
                    copper: place === 3
                };
            },
            schoolGrades (school) {
                return this.rating.user.grades.filter(grade => grade.schoolId === school.id);
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            place () {
                return this.rating.computedPosition;
            },
            color () {
                return this.getColor(this.place);
            },
            places () {
                this.rating.user.ratings = this.rating.user.ratings.filter(rating => rating.for === this.rating.for);
                return this.rating.user.ratings.reduce((places, rating) => {
                    if (
                            (places[rating.type] && places[rating.type] < rating.position)
                            || (!places[rating.type] || places[rating.type] === 0)
                    ) {
                        places[rating.type] = rating.position;
                    }
                    return places;
                }, {});
            },
            userPreviewClasses () {
                switch (this.place) {
                    case 1:
                        return 'user-preview--gold';
                    case 2:
                        return 'user-preview--silver';
                    case 3:
                        return 'user-preview--copper';
                    default:
                        return ;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    $gold: #FFAD1F;
    $silver: #858585;
    $copper: #A44020;

    .gold {
        color: $gold;
    }
    .silver {
        color: $silver;
    }
    .copper {
        color: $copper;
    }

    .user-preview {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        padding: 16px;
    }

    .user-preview--gold {
        border: 1px solid $gold;
    }

    .user-preview--silver {
        border: 1px solid $silver;
    }

    .user-preview--copper {
        border: 1px solid $copper;
    }

    .user-preview__place {
        font-size: 24px;
        line-height: 30px;
        text-align: center;
        margin-left: 10px;
    }

    .user-preview__icon {
        color: $hsl-color-green-58;
    }

    .user-preview__column {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0;
        margin-bottom: 16px;
        @include media($xlg) {
            margin-bottom: 0;
        }
    }

    .user-preview__column_with-trophy {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .user-preview__column:last-child {
        margin-bottom: 0;
    }

    .user-preview__info {
        margin: -8px 0;
    }

    .info__column {
        display: flex;
        align-items: center;
        padding: 8px 0;
    }

    .preview__text {
        margin-left: 8px;
    }

    .user-preview__link {
        text-decoration-line: underline;
        color: $x-color-black;
        &:hover {
            text-decoration-line: underline;
            color: $x-color-black;
        }
    }

    .user-info {
        margin-top: 8px;
    }
</style>
